import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EditAgeHoursSkeleton = () => (
  <>
    <SectionSkeleton height={160} />
    <Divider />
    <SectionSkeleton height={100} />
    <Divider />
    <SectionSkeleton height={100} />
  </>
);
